<template>
  <div>
    <el-container>
        <el-aside width="auto"><CommonAside></CommonAside></el-aside>
        <el-container>
        <el-header>
        <!-- 头组件 -->
          <commonHeader></commonHeader>
        </el-header>
        <commonTag></commonTag>
        <el-main>
            <!-- 匹配路由 -->
            <router-view></router-view>
        </el-main>
        </el-container>
    </el-container>
    

  </div>
</template>

<script>
import commonTag from '@/components/CommonTag.vue';
import commonHeader from '@/components/CommonHeader.vue';
import CommonAside from '@/components/CommonAside'
export default {
    components:{
        CommonAside,commonHeader,commonTag
    }
}
</script>

<style lang="less" scoped>
.el-header{
  padding: 0;
}


</style>